// GLOBAL ACTIONS
export const CLEAR_DATA = '@app/CLEAR_DATA';

// INTL ACTIONS
export const SET_LOCALE = '@intl/SET_LOCALE';

// GRAPH ACTIONS

// - EVENTS
export const CLEAR_EVENTS_DATA = '@events/CLEAR_EVENTS_DATA';
export const FETCH_EVENTS = '@events/FETCH_EVENTS';
export const FETCH_EVENTS_REQUEST = '@events/FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = '@events/FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_PARTIAL_SUCCESS = '@events/FETCH_EVENTS_PARTIAL_SUCCESS';
export const FETCH_EVENTS_FAILURE = '@events/FETCH_EVENTS_FAILURE';

// - ROOMS
// -- LIST
export const CLEAR_ROOM_DATA = '@rooms/CLEAR_ROOM_DATA';
export const FETCH_ROOM_LIST = '@rooms/FETCH_ROOM_LIST';
export const FETCH_ROOM_LIST_REQUEST = '@rooms/FETCH_ROOM_LIST_REQUEST';
export const FETCH_ROOM_LIST_SUCCESS = '@rooms/FETCH_ROOM_LIST_SUCCESS';
export const FETCH_ROOM_LIST_FAILURE = '@rooms/FETCH_ROOM_LIST_FAILURE';
// -- EVENTS
export const FETCH_ROOM_EVENTS = '@rooms/FETCH_ROOM_EVENTS';
export const FETCH_ROOM_EVENTS_REQUEST = '@rooms/FETCH_ROOM_EVENTS_REQUEST';
export const FETCH_ROOM_EVENTS_SUCCESS = '@rooms/FETCH_ROOM_EVENTS_SUCCESS';
export const FETCH_ROOM_EVENTS_PARTIAL_SUCCESS = '@rooms/FETCH_ROOM_EVENTS_PARTIAL_SUCCESS';
export const FETCH_ROOM_EVENTS_FAILURE = '@rooms/FETCH_ROOM_EVENTS_FAILURE';


// GOOGLE ACTIONS

// - BIRTHDAYS
export const LOAD_BIRTHDAYS_SPREADSHEET = '@birthdays/LOAD_BIRTHDAYS_SPREADSHEET';
export const LOAD_BIRTHDAYS_SPREADSHEET_REQUEST = '@birthdays/LOAD_BIRTHDAYS_SPREADSHEET_REQUEST';
export const LOAD_BIRTHDAYS_SPREADSHEET_SUCCESS = '@birthdays/LOAD_BIRTHDAYS_SPREADSHEET_SUCCESS';
export const LOAD_BIRTHDAYS_SPREADSHEET_FAILURE = '@birthdays/LOAD_BIRTHDAYS_SPREADSHEET_FAILURE';

// - POLISH
export const CLEAR_POLISH_DATA = '@polish/CLEAR_POLISH_DATA';
export const FETCH_POLISH_DATA = '@polish/FETCH_POLISH_DATA';
export const FETCH_POLISH_DATA_REQUEST = '@polish/FETCH_POLISH_DATA_REQUEST';
export const FETCH_POLISH_DATA_SUCCESS = '@polish/FETCH_POLISH_DATA_SUCCESS';
export const FETCH_POLISH_DATA_FAILURE = '@polish/FETCH_POLISH_DATA_FAILURE';

// - USER
export const ADD_USER = '@users/ADD_USER';
export const ADD_USER_REQUEST = '@users/ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = '@users/ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = '@users/ADD_USER_FAILURE';
export const LOG_USER_OUT = '@users/LOG_USER_OUT';
export const REMOVE_USER = '@users/REMOVE_USER';
export const REMOVE_USER_REQUEST = '@users/REMOVE_USER_REQUEST';
export const REMOVE_USER_SUCCESS = '@users/REMOVE_USER_SUCCESS';
export const REMOVE_USER_FAILURE = '@users/REMOVE_USER_FAILURE';
export const UPDATE_USER = '@users/UPDATE_USER';
export const UPDATE_USER_REQUEST = '@users/UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = '@users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = '@users/UPDATE_USER_FAILURE';


// OPEN WEATHER MAP ACTIONS
export const FETCH_WEATHER_BY_CITY_ID = '@weather/FETCH_WEATHER_BY_CITY_ID';
export const FETCH_WEATHER_BY_CITY_ID_REQUEST = '@weather/FETCH_WEATHER_BY_CITY_ID_REQUEST';
export const FETCH_WEATHER_BY_CITY_ID_SUCCESS = '@weather/FETCH_WEATHER_BY_CITY_ID_SUCCESS';
export const FETCH_WEATHER_BY_CITY_ID_FAILURE = '@weather/FETCH_WEATHER_BY_CITY_ID_FAILURE';

export const FIND_WEATHER_CITY_ID = '@weather/FIND_WEATHER_CITY_ID';
export const FIND_WEATHER_CITY_ID_REQUEST = '@weather/FIND_WEATHER_CITY_ID_REQUEST';
export const FIND_WEATHER_CITY_ID_SUCCESS = '@weather/FIND_WEATHER_CITY_ID_SUCCESS';
export const FIND_WEATHER_CITY_ID_FAILURE = '@weather/FIND_WEATHER_CITY_ID_FAILURE';


// SNACKBAR ACTIONS
export const ADD_SNACKBAR = '@snackbar/ADD_SNACKBAR';
export const REMOVE_SNACKBAR = '@snackbar/REMOVE_SNACKBAR';


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js